import { action } from '@reatom/framework'

import type { BackOfficeUser } from '@root/entities/back-office'

export interface OpenBackOfficeUsersWalletsModalPayload {
  user: BackOfficeUser.BackOfficeUser
}

export const openBackOfficeUsersWalletsModalEvent =
  // eslint-disable-next-line @reatom/unit-naming-rule
  action<OpenBackOfficeUsersWalletsModalPayload>(
    'openBackOfficeUsersWalletsModalEvent',
  )
